<p-drawer
  [(visible)]="visible"
  position="right"
  styleClass="!w-full md:!w-1/2 lg:!w-1/3"
>
  <ng-template #headless>
    <div class="flex justify-between items-center w-full p-4">
      <h3 class="m-0">Edit Shipping & Packaging</h3>
      <p-confirmpopup />
      <button
        pButton
        icon="pi pi-times"
        class="p-button-text p-button-plain"
        (click)="confirmClose($event)"
      ></button>
    </div>
    <div class="p-4">
      <div class="flex flex-col gap-6">
        <div>
          <h4 class="mb-4">Shipping</h4>
          <app-price-setting
            [costField]="editForm.shippingCost"
            [markupField]="editForm.shippingMarkup"
            [markupPercentField]="editForm.shippingMarkupPercent"
            [priceField]="editForm.shippingPrice"
            [currencyCode]="quoteService.revision.currency_code"
          />
        </div>

        <p-divider />

        <div>
          <h4 class="mb-4">Packaging</h4>
          <app-price-setting
            [costField]="editForm.packagingCost"
            [markupField]="editForm.packagingMarkup"
            [markupPercentField]="editForm.packagingMarkupPercent"
            [priceField]="editForm.packagingPrice"
            [currencyCode]="quoteService.revision.currency_code"
          />
        </div>

        <p-divider />

        <div class="flex justify-end gap-2">
          <p-button
            label="Cancel"
            severity="secondary"
            (onClick)="confirmClose($event)"
            [disabled]="isSaving()"
          />
          <p-button
            label="Save"
            icon="pi pi-save"
            (onClick)="saveChanges()"
            [loading]="isSaving()"
            [disabled]="!editForm().dirty() || isSaving()"
          />
        </div>
      </div>
    </div>
  </ng-template>
</p-drawer>
